import styled from "styled-components";

export const FormContainer = styled.div`
  background-color: #ffffff2f;
  padding: 20px;
  text-align: center;
  width: 300px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Input = styled.input`
  padding: 10px;
  font-size: 15px;
  border: 1px solid #000000;
  border-radius: 20px;
`;

